import { makeStyles } from "@material-ui/styles"
import { CELL_PADDING, CELL_WIDTHS } from "@utils";

const useStyle = makeStyles(() => ({
  dragHandleCell: {
    position: "sticky",
    fontSize: 24,
    padding: CELL_PADDING,
    left: 0,
    zIndex: 5,
    width: CELL_WIDTHS.DRAG_HANDLE,
    minWidth: CELL_WIDTHS.DRAG_HANDLE,
  },
}));

export default useStyle;
